import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aa7c590"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "education" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "EDUCATION", -1))

import { reactive } from 'vue';
  import CardImg from '@/components/CardImg.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EducationView',
  setup(__props) {

  const eduTitle = reactive([
      {
        id:0, 
        title:'Student Benefit', 
        img:'edu1.jpg', 
        route:'/student', 
        desc:'Maximize your learning experience with exclusive student benefits'
      },
      {
        id:1, 
        title:'RTO Partners', 
        img:'edu2.jpg', 
        route:'/rto', 
        desc:'Join a network of leading Registered Training Organizations'
      },
      {
        id:3, 
        title:'Upcoming Events - free seminars', 
        img:'edu3.jpg', 
        route:'/event', 
        desc:'Join free seminars to dicuss with us about the latest information'
      },
      // {
      //   id:2, 
      //   title:'Current Courses', 
      //   img:'edu3.jpg', 
      //   route:'/course', 
      //   desc:'Stay ahead with our dynamic selection of up-to-date courses'
      // }
  ]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(CardImg, { value: eduTitle }, null, 8, ["value"])
  ]))
}
}

})